import classNames from 'classnames';
import { FC } from 'react';

import styles from '../TextHighlighter.styles.m.css';
import { THighlightLayout } from '../TextHighlighter.types';

interface ITextHighlighterRangeProps extends THighlightLayout {}

export const TextHighlighterRange: FC<ITextHighlighterRangeProps> = (props) => {
  const style = {
    left: `${props.left}px`,
    width: `${props.right - props.left}px`,
    minHeight: `${props.bottom - props.top}px`,
  };

  const rangeClassName = classNames(
    styles.range,
    props.touches.map((touch) => styles[`${touch}-touch`])
  );

  return (
    <span
      style={style}
      className={rangeClassName}
    />
  );
};
